/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// @ts-nocheck

import { customElement } from 'lit/decorators.js';

import { styles as secondaryStyles } from '@material/web/tabs/internal/secondary-tab-styles.js';
import { styles as sharedStyles } from '@material/web/tabs/internal/tab-styles.js';
import { SecondaryTab } from './internal/secondary-tab.js';

// TODO(b/267336507): add docs
/**
 * @summary Tab allow users to display a tab within a Tabs.
 *
 */
@customElement('md-secondary-tab')
export class MdSecondaryTab extends SecondaryTab {
  static override styles = [sharedStyles, secondaryStyles];
}

declare global {
  interface HTMLElementTagNameMap {
    'md-secondary-tab': MdSecondaryTab;
  }
}
